import { MeetingAvailabilityResourceTypeMappings } from '@aa/nest/resource';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { formatDateTime, weekdayOptions } from '@aa/ts/common';
import { DataTableColumnConfig } from '../../components/data-table/data-table.component';
import {
  BaseResourceListViewComponent,
  baseResourceListViewImports,
} from '../base-resource-list-view/base-resource-list-view.component';
import { MeetingAvailabilityFormModalComponent } from '../../forms/meeting-availability-form-modal/meeting-availability-form-modal.component';
import { meetingAvailabilityActions } from '../../state/meeting-availability/meeting-availability.actions';
import { selectMeetingAvailabilityState } from '../../state/meeting-availability/meeting-availability.reducer';
import { Prisma } from '@prisma/client';

@Component({
  selector: 'aa-meeting-availabilities-list-view',
  standalone: true,
  imports: [...baseResourceListViewImports],
  templateUrl:
    '../../../../../core/src/lib/views/base-resource-list-view/base-resource-list-view.component.html',
  styleUrl:
    '../../../../../core/src/lib/views/base-resource-list-view/base-resource-list-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeetingAvailabilitiesListViewComponent extends BaseResourceListViewComponent<MeetingAvailabilityResourceTypeMappings> {
  title = 'Meeting Availability';
  columns = [
    // {
    //   key: 'id',
    //   label: 'ID',
    //   minWidth: '3rem',
    // },
    {
      key: 'weekday',
      label: 'Weekday',
      accessor: (row) => weekdayOptions[row.weekday],
    },
    {
      key: 'startTime',
      label: 'Start Time',
    },
    {
      key: 'endTime',
      label: 'End Time',
    },
    {
      key: 'createdAt',
      label: 'Created At',
      accessor: (row) => formatDateTime(row.createdAt),
      minWidth: '15rem',
    },
    {
      key: 'updatedAt',
      label: 'Updated At',
      accessor: (row) => formatDateTime(row.updatedAt),
      minWidth: '15rem',
    },
  ] as DataTableColumnConfig<
    MeetingAvailabilityResourceTypeMappings['resourceWithRelationsT']
  >[];

  stateSelector = selectMeetingAvailabilityState;
  loadAction = meetingAvailabilityActions.loadItems({
    query: {
      pageSize: this.initialPageSize,
    },
  });
  actions = meetingAvailabilityActions;

  createFormModalTypeGetter = () => MeetingAvailabilityFormModalComponent;
  updateFormModalTypeGetter = () => MeetingAvailabilityFormModalComponent;

  override orderBy: Prisma.MeetingAvailabilityOrderByWithRelationInput = {
    weekday: 'asc',
  };
}
